import FallbackLoader from '@async-components/FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-HiddenAdsFeedback" */'./index'));
